import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Alert, Button, Code, Container, Stack } from '@mantine/core'
import { formatParseErrorIssues } from '@/shared/api/formatParseError'

export function RouteError({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation()
  const { reset: resetQueryErrors } = useQueryErrorResetBoundary()
  const validationIssues = formatParseErrorIssues(error)

  const retry = () => {
    resetQueryErrors()
    reset()
  }

  return (
    <Container py="xl">
      <Alert color="red" title={t('common.unexpectedError')}>
        <Stack align="flex-start">
          {error instanceof Error ? error.message : String(error)}
          {validationIssues.map((issue) => (
            <Code key={issue}>{issue}</Code>
          ))}
          <Button variant="default" onClick={retry}>
            {t('common.retry')}
          </Button>
        </Stack>
      </Alert>
    </Container>
  )
}
